<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        :width="width"
        :height="height" 
        viewBox="0 0 16 16" 
        fill="none"
    >
        <path d="M6.66667 2.66675H4V13.3334H6.66667V2.66675Z" 
        :fill="iconColor"
        />
        <path d="M12 2.66675H9.33331V13.3334H12V2.66675Z" 
        :fill="iconColor"
        />
    </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>